// extracted by mini-css-extract-plugin
export default {"alertContainer":"styles_alertContainer__F9stE","alertIcon":"styles_alertIcon__ZdxkS"};